<template>
  <v-list-item
    style="padding-inline-start: calc(15px + 1rem + 4px)"
    :to="{ name: 'service', params: { serviceId: service.serviceId } }"
  >
    <v-list-item-content>
      <v-list-item-title v-text="service.nom" />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'service-list-item',
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
}
</script>
